import React, { useState } from "react";
import styled, { keyframes, css } from "styled-components";
import { Link } from "gatsby";

//assets
import logo from "assets/svg/logo.svg";

//styles
import colors from "styles/colors.js";
import typographySizes from "styles/typographySizes.js";
import distances from "styles/distances.js";
import mediaQuery from "styles/mediaQuery.js";

//components
import MainWrapper from "components/global/MainWrapper.js";
import NavLinks from "components/global/nav/NavLinks.js";

const NavContainer = styled.div`
position: absolute;
top:0 ;
left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;



`;

const TopWrapper = styled.div`
position: absolute;
pointer-events: auto;
top:  calc(50dvh);
transform: translateY(-100%);
left: 0;
padding-bottom:  ${distances.pageMarginBig}rem;
width: 100%;
z-index: 1000;
>div{
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  height: 100%;
}

@media (max-width: ${mediaQuery.tablet}) {
  padding-bottom:  calc(${distances.pageMarginSmall}rem + 1rem)
}

`;

const Logo = styled.img`
height: 5rem;
object-fit: contain;
`;

const LangLink = styled(Link)`
text-decoration: none;
text-transform: uppercase;
font-size: ${typographySizes.text.tekstSize1.size.desktop}rem;

`;

const Nav = ({ locale, langLink }) => {
  const [logoClickTick, setLogoClickTick] = useState(0);

  const handleLogoClick = () => {
    setLogoClickTick((prev) => prev + 1);
  };

  return (
    <>
      <NavContainer>
        <TopWrapper>
          <MainWrapper>
            <Link
              to={locale === "en" ? "/" : "/pl/home"}
              onClick={handleLogoClick}
            >
              <Logo src={logo} alt="Logo" />
            </Link>
            {/* <LangLink to={langLink}>[{locale === "en" ? "PL" : "EN"}]</LangLink> */}
          </MainWrapper>
        </TopWrapper>
        <NavLinks locale={locale} logoClickTick={logoClickTick} />
        <NavLinks locale={locale} bottom logoClickTick={logoClickTick} />
      </NavContainer>
    </>
  );
};

export default Nav;
